<template>
  <dropdown class="rui-help-button" theme="help">
    <rui-button :title="$t('rui.help_button.help')"
                icon="rui:help"
                variant="helping"
                class="rui-help-button__trigger"
                text />
    <template v-if="content || $slots.default" #popper>
      <div class="rui-help-button__content">
        <!-- @slot Default slot. Overrides `content` props -->
        <slot>{{ content }}</slot>
      </div>
    </template>
  </dropdown>
</template>

<script>
import { Dropdown, options as floatingOptions } from 'floating-vue'
import RuiButton from '../Button/Button.vue'

floatingOptions.themes.help = { $extend: 'dropdown', $resetCss: true }

/**
 * Button which displays some help once clicked
 *
 * **Note:** This component depends on the `floating-vue` library
 *
 * @preset Using prop { "props": { "content": "Here, some help" } }
 * @preset Using slot { "slots": { "default": "<div><em>Here</em>, <strong>some help!</strong><div>\n<div>And it's wrapped in HTML!</div>" } }
 */
export default {
  name: 'RuiHelpButton',
  components: { RuiButton, Dropdown },
  props: {
    /** Text content. Is overridden by default slot */
    content: { required: false, type: String, default: null },
  },
}
</script>
